import AuthLayoutTemplate from "~/layouts/auth/auth-simple-layout";

export type AuthBranding = {
  companyName: string;
  logoUrl: string | null;
  primaryColor: string;
  primaryForeground: "#111827" | "#ffffff";
};

export default function AuthLayout({
  children,
  title,
  description,
  ...props
}: {
  children: React.ReactNode;
  title: string;
  description: string;
  variant?: "default" | "light";
  branding?: AuthBranding;
}) {
  return (
    <AuthLayoutTemplate title={title} description={description} {...props}>
      {children}
    </AuthLayoutTemplate>
  );
}
